import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import "../../../index.css";
import LaptopWindows from "@mui/icons-material/LaptopWindows";
import CalendarMonthOutlined from "@mui/icons-material/CalendarMonthOutlined";
import PolicyOutlined from "@mui/icons-material/PolicyOutlined";
import FormatListBulleted from "@mui/icons-material/FormatListBulleted";
import EventOutlined from "@mui/icons-material/EventOutlined";

function leavePage() {
  return (
    <div className=" p-2">
      <span className="title">Leave Setting</span>
      <div className="grid-container text-center mt-4">
        <div className="grid-item">
          <div className="setting-layout text-center p-5 rounded">
            <div className="setting1">
              <div className=" mt-1">
                <Link
                  to="/leave-page/working-days"
                  className=" setting-layout text-decoration-none"
                >
                  <LaptopWindows className="icon-setting mb-3" />
                  <span
                    className="text-decoration-none"
                    style={{ color: "#505050" }}
                  >
                    Working Days
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="grid-item">
          <div className="setting1">
            <Link
              to="/leave-page/holiday-calander"
              className="setting-layout text-decoration-none"
            >
              <CalendarMonthOutlined className="icon-setting mb-3" />
              <span
                className="text-decoration-none"
                style={{ color: "#505050" }}
              >
                Holidays
              </span>
            </Link>
          </div>
        </div>

        <div className="grid-item">
          <div className="setting1">
            <div className="">
              <Link
                to="/leave-page/time-off-policy"
                className="setting-layout text-decoration-none"
              >
                <PolicyOutlined className="icon-setting mb-3" />
                <span
                  className="text-decoration-none"
                  style={{ color: "#505050" }}
                >
                  Leave Policy
                </span>
              </Link>
            </div>
          </div>
        </div>

        <div className="grid-item">
          <div className="setting1">
            <div className="setting-link mt-3 d-flex flex-column">
              <Link
                to="/leave-page/leave-type"
                className="setting-layout text-decoration-none"
              >
                <FormatListBulleted className="icon-setting mb-3" />
                <span
                  className="text-decoration-none"
                  style={{ color: "#505050" }}
                >
                  Leave Type
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div className="grid-item">
          <div className="setting1">
            <div className="">
              <Link
                to="/leave-page/time-off-policy/leave-policy-details/add-restricted-dates"
                className="setting-layout text-decoration-none"
              >
                <EventOutlined className="icon-setting mb-3" />
                <span
                  className="text-decoration-none"
                  style={{ color: "#505050" }}
                >
                  Restricted Date
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default leavePage;
